<template>
  <div class="container">
    <div v-if="parseInt($store.state.config.user.level) < 99" class="border-decoration">
      <h1 class="is-title">System updates (20/06/2025):</h1>
      <ul class="list-decoration">
        <li>Ajustado erro no registro de no-rule em novas Payment Orders (Payments V2) (27/03/2025).</li>
        <li>Adicionado Card Tag(Year) 2023 em Edit Paid Payment Orders (03/04/2025).</li>
        <li>Adicionado opção de "Hide" para users externos inativos (25/04/2025).</li>
        <li>O botão "New Card" foi ajustado, agora é exibido apenas quando o cartão da reserva está "CANCELLED" (28/04/2025).</li>
        <li>Adicionado opção de inserir "Card Tag" em PO's pagas no cartão, também incluído filtro por "Card Tag", no Payments Orders (V1) (02/05/2025).</li>
        <li>Ajustado o envio de cartão DIRECT através do Charges V2 (08/05/2025).</li>
        <li>Adicionado a trava MCC para novos cartões (Clara) (14/05/2025).</li>
        <li>Disponibilizado a visualização do virtual card para reservas com cartão (Jeeves) feitas através da integração (20/05/2025).</li>
        <li>Adicionado a possibilidade de vincular mais de uma plataforma por agência. (Agencies/Relationship) (26/05/2025).</li>
        <li>Porcentagem do IOF usado no cálculo da conversão, alterado para 3.64% (Invoices V2/Pay) (28/05/2025).</li>
        <li>Adicionado a conciliação automática do Jeeves, também disponibilizado a opção Jeeves no "New Card" (Services/Finances) (11/06/2025).</li>
        <li>Disponibilizado a visualização de todos os 'integrated systems' vinculados a agência através da tabela (Agencies) (18/06/2025).</li>
        <li>Disponibilizado dentro do serviço, o histórico para transações com cartões Jeeves (20/06/2025).</li>
      </ul>
      <span><b>I.T. Department</b> ❤️</span>
    </div>
    <img id="logo" src="~assets/eztourlogo.png" alt="EZ Link" v-if="parseInt($store.state.config.user.level) < 99">
    <img id="logoClient" src="~assets/bw.png" alt="EZ Link" v-if="parseInt($store.state.config.user.level) === 99">
  </div>
</template>



<script>
  import Alert from '../components/notifications/alert'
  export default {
    data () {
      return {}
    },
    mounted () {
      if (parseInt(this.$store.state.config.user.level) === 99) {
        document.getElementById('logoClient').style.marginTop = 25 + '%'
      }
      if (((this.$store.state.config.show_alert === null) || (this.$store.state.config.show_alert === true)) && (parseInt(this.$store.state.config.user.level) > 4)) {
        let propsData = {
          context: this
        }
        Alert.openAlert(propsData)
      }
    },
    components: {
    }
  }
</script>

<style lang="scss" scoped>

  .container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .is-title {
    text-transform: capitalize;
    font-size: 2rem;
    margin-bottom: 2rem;
  }

  .list-decoration {
    list-style-type: disc;
    display: flex;
    flex-direction: column;
  }

  .list-decoration li {
    margin-bottom: 1rem;
    margin-left: 1rem;
  }

  .border-decoration {
    border-style: groove;
    border-radius: 1rem;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
  }

  #logo {
    margin-top: 5%;
  }

</style>



// WEBPACK FOOTER //
// Home.vue?12800066